/* Konflikt: Die verbundene Karte wurde auf dem Server geändert. Der Benutzer entscheidet; es wird nichts still überschrieben. */
import { useState } from 'react';
import type { CloudLink } from '../net/cloud.ts';
import { Dialog, DialogBody, DialogFoot } from './dialog.tsx';
import { useStore, useT } from './hooks.ts';

export function ConflictDialog(props: { cloud: CloudLink; onDone: () => void }) {
  const t = useT();
  const snap = useStore(props.cloud);
  const name = snap.link?.name || '';
  const [copy, setCopy] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const run = async (fn: () => Promise<unknown>) => {
    try { await fn(); props.onDone(); } catch (e) { setErr(t('cloud.save_failed', { msg: (e as Error).message })); }
  };
  return (
    <Dialog title={t('cloud.conflict_title')} onClose={() => { props.cloud.dismissConflict(); props.onDone(); }}>
      <DialogBody>
        <p>{t('cloud.conflict_text', { name })}</p>
        {copy !== null && (
          <div className="row">
            <label htmlFor="xf-copy-name">{t('cloud.copy_name')}</label>
            <input id="xf-copy-name" type="text" className="inp" maxLength={120} value={copy} onChange={(e) => setCopy(e.target.value)} autoFocus />
          </div>
        )}
        {err && <p className="small" role="status">{err}</p>}
      </DialogBody>
      <DialogFoot>
        <button className="btn" onClick={() => { props.cloud.dismissConflict(); props.onDone(); }}>{t('cloud.later')}</button>
        {copy === null
          ? <button className="btn" onClick={() => setCopy(name + ' (2)')}>{t('cloud.save_copy')}</button>
          : <button className="btn" disabled={!copy.trim()} onClick={() => void run(() => props.cloud.saveAsCopy(copy.trim()))}>{t('cloud.save_new')}</button>}
        <button className="btn" onClick={() => void run(() => props.cloud.loadServer())}>{t('cloud.load_server')}</button>
        <button className="btn primary" onClick={() => void run(() => props.cloud.overwrite())}>{t('cloud.overwrite')}</button>
      </DialogFoot>
    </Dialog>
  );
}
